<template>
  <Card class="layout-card" style="height: 100%">
    <div style="flex-shrink: 0">
      <Row :gutter="20">
        <Col :span="20">
          <Row :gutter="20">
            <Col :span="6">
              <Select
                v-model="searchForm.goodsType"
                placeholder="请选择付费类型"
                clearable
              >
                <Option :value="0">充值金币</Option>
                <Option :value="1">开通VIP</Option>
                <Option :value="2">通行证</Option>
              </Select>
            </Col>
            <!-- <Col :span="6">
          <Select v-model="searchForm.payStatus" placeholder="请选择支付状态" clearable>
            <Option :value="0">支付成功</Option>
            <Option :value="1">取消支付</Option>
            <Option :value="2">支付失败</Option>
            <Option :value="3">未支付</Option>
            <Option :value="4">超时未支付</Option>
          </Select>
          </Col> -->
            <Col :span="6">
              <Input
                style="width: 100%"
                :maxlength="100"
                v-model="searchForm.googleOrderNo"
                placeholder="请输入谷歌订单号"
              />
            </Col>
            <Col :span="6">
              <Select
                v-model="searchForm.payMethods"
                placeholder="请选择支付方式"
                clearable
                multiple
                :max-tag-count="2"
              >
                <Option :value="0">Google Pay</Option>
                <Option :value="1">Apple Pay</Option>
                <!-- <Option :value="2">Google Test Pay</Option>
            <Option :value="3">Apple Test Pay</Option>
            <Option :value="4">antom Google pay</Option>
            <Option :value="5">antom Apple pay</Option>
            <Option :value="6">antom card</Option>
            <Option :value="7">antom test Google pay</Option>
            <Option :value="8">antom test Apple pay</Option>
            <Option :value="9">antom test card</Option> -->
              </Select>
            </Col>
            <Col :span="6">
              <Input
                :maxlength="100"
                v-model="searchForm.userId"
                placeholder="请输入用户ID"
              />
            </Col>
            <Col :span="6">
              <InputNumber
                style="width: 100%"
                :maxlength="100"
                v-model="searchForm.goodsId"
                placeholder="请输入付费项ID"
              />
            </Col>
            <Col :span="6">
              <Input
                :maxlength="100"
                v-model="searchForm.goodsName"
                placeholder="请输付费项名称"
              />
            </Col>
            <Col :span="6">
              <Input
                :maxlength="100"
                v-model="searchForm.orderNo"
                placeholder="请输入订单号"
              />
            </Col>
            <Col :span="6">
              <DatePicker
                :editable="false"
                :value="listDate"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                placeholder="请选择创建时间"
                @on-change="getListDate"
              >
              </DatePicker>
            </Col>
            <Col :span="6">
              <DatePicker
                :editable="false"
                :value="listDate1"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                placeholder="请选择支付时间"
                @on-change="getListDate1"
              >
              </DatePicker>
            </Col>
          </Row>
        </Col>
        <Col :span="4">
          <Row>
            <Col
              ><Button
                type="primary"
                style="width: 100%"
                v-if="buttonMenu['/user-order/view']"
                @click="getData()"
                >查询</Button
              ></Col
            >
          </Row>
          <Row>
            <Col
              ><Button style="width: 100%" @click="handleReset()"
                >重置</Button
              ></Col
            >
          </Row>
          <Row v-if="buttonMenu['/user-order/export']">
            <Col
              ><Button
                style="width: 100%"
                @click="handleExport()"
                type="warning"
                >导出</Button
              ></Col
            >
          </Row>
        </Col>
      </Row>
    </div>
    <div style="height: 100%; overflow: auto">
      <Table :data="tableData" :columns="columns" :loading="loading">
        <template #action="{ row }">
          <div>
            <a
              style="margin-left: 10px"
              v-if="buttonMenu['/user-order/info']"
              @click="handleOpenModal(row)"
              >详情</a
            >
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>

    <Modal v-model="editVisible" fullscreen :title="'订单详情'">
      <div v-if="editVisible">
        <Card title="用户信息" style="margin-bottom: 10px">
          <Form @submit.native.prevent :label-width="200">
            <Row>
              <Col :span="8">
                <FormItem label="用户ID：">
                  {{ form.userId }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="用户昵称：">
                  {{ form.userNickName }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="用户类型：">
                  {{ form.userTypeName }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="原VIP有效日期：">
                  {{ form.vipOriginalTimeFmt }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="开通后日期：">
                  {{ form.vipRechargedTimeFmt }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="原金币数：">
                  {{ form.goodsOriginalNum }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="充值后金币数：">
                  {{ form.goodsRechargedNum }}
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Card>
        <Card title="付费信息" style="margin-bottom: 10px">
          <Form @submit.native.prevent :label-width="200">
            <Row>
              <Col :span="8">
                <FormItem label="付费项ID：">
                  {{ form.goodsId }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="付费项类型：">
                  {{ form.goodsTypeName }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="付费项名称：">
                  {{ form.goodsName }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="开通时长：">
                  {{
                    form.payMethod == 0
                      ? form.googleExpireTimeFmt
                      : form.vipExpireTime
                  }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="充值金币数量：">
                  {{ form.payBalance }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="赠送金币数量：">
                  {{ form.bonusBalance }}
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Card>
        <Card title="订单信息">
          <Form @submit.native.prevent :label-width="200">
            <Row>
              <Col :span="8">
                <FormItem label="订单号：">
                  {{ form.orderNo }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="创建时间：">
                  {{ form.createTimeFmt }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="支付状态：">
                  {{ form.payStatusName }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="支付费用：">
                  {{ form.goodsPrice }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="支付方式：">
                  {{ form.payMethodName }}
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem label="支付时间：">
                  {{ form.payTimeFmt }}
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
      <template #footer>
        <Button @click="editVisible = false">关闭</Button>
      </template>
    </Modal>
  </Card>
</template>

<script>
import dayjs from 'dayjs'
import Pages from '@/components/pages'
import {
  getOrderList,
  addOrder,
  delOrder,
  editOrder,
  getOrderInfo,
  getOrderExcel
} from '@/api/order'
export default {
  components: {
    Pages
  },
  data() {
    return {
      editVisible: false,
      form: {},
      searchForm: {
        goodsId: ''
      },
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      listDate: [],
      columns: [
        {
          title: '订单号',
          key: 'orderNo'
        },
        {
          title: '用户',
          key: 'userId'
        },
        {
          title: '付费项id',
          key: 'goodsId'
        },
        {
          title: '付费项名称',
          key: 'goodsName'
        },
        {
          title: '付费类型',
          key: 'goodsTypeName'
        },
        {
          title: '支付费用（美元）',
          key: 'goodsPriceFmt',
          width: 150
        },
        {
          title: '支付方式',
          key: 'payMethodName'
        },
        {
          title: '支付状态',
          key: 'payStatusName'
        },
        {
          title: '创建时间',
          key: 'createTimeFmt'
        },
        {
          title: '支付时间',
          key: 'payTimeFmt'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ],
      listDate1: []
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('user/user-order')
      const obj = {}
      li.forEach((i) => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods: {
    getListDate(data) {
      const endDate = data[1]
        ? dayjs(data[1]).hour(23).minute(59).second(59).format('YYYY-MM-DD HH:mm:ss')
        : ''
      this.listDate = [data[0], endDate]
      this.searchForm.startDate = data[0]
      this.searchForm.endDate = endDate
    },
    getListDate1(data) {
      const endDate = data[1]
        ? dayjs(data[1]).hour(23).minute(59).second(59).format('YYYY-MM-DD HH:mm:ss')
        : ''
      this.listDate1 = [data[0], endDate]
      this.searchForm.payTimeStart = data[0]
      this.searchForm.payTimeEnd = endDate
    },

    handleExport() {
      getOrderExcel({
        ...this.searchForm,
        payStatus: 0,
        payMethods: this.searchForm.payMethods
          ? this.searchForm.payMethods.join(',')
          : null
      }).then((r) => {
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = r.data.fileUrl

        // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'),r.data.fileUrl.length)
        link.setAttribute('download', r.data.fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      this.loading = true
      getOrderList({
        ...this.page,
        ...this.searchForm,
        payStatus: 0,
        payMethods: this.searchForm.payMethods
          ? this.searchForm.payMethods.join(',')
          : null
      })
        .then(({ data }) => {
          console.log(data)

          this.tableData = data.records
          this.page.current = data.current
          this.page.total = data.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleOpenModal(row) {
      if (row) {
        const r = await getOrderInfo(row.id)
        this.form = r.data
      } else {
        this.form = {}
      }
      this.editVisible = true
    },
    handleSubmit() {
      if (!this.form.orderPath) {
        this.$Message.error('请输入权限地址')
        return
      }
      if (!this.form.orderName) {
        this.$Message.error('请输入权限名称')
        return
      }

      const func = this.form.id ? editOrder : addOrder
      func({
        ...this.form
      }).then((r) => {
        this.$Message.success('操作成功')
        this.getData()
        this.editVisible = false
      })
    },
    handleDel(row) {
      delOrder(row.id).then((r) => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {
        goodsId: ''
      }
      this.listDate = []
      this.listDate1 = []
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;

  & > * {
    margin: 0 5px;
  }
}

.ivu-row {
  .ivu-col {
    margin-bottom: 15px;
  }
}
/deep/.ivu-row {
  .ivu-form-item-label {
    font-size: 15px;
  }
  .ivu-form-item-content {
    font-size: 15px;
  }
}
.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
